import { render, staticRenderFns } from "./RegisteredSpectatorGlobal.vue?vue&type=template&id=456bbf8e&"
import script from "./RegisteredSpectatorGlobal.vue?vue&type=script&lang=js&"
export * from "./RegisteredSpectatorGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports